// src/utils/slots.js
export const SIX_HOURS = 6 * 60 * 60 * 1000;

export function currentSlotKey(ts = Date.now()) {
  return String(Math.floor(ts / SIX_HOURS));
}

export function slotWindow(ts = Date.now()) {
  const start = Math.floor(ts / SIX_HOURS) * SIX_HOURS;
  const end = start + SIX_HOURS - 1;
  return { start, end };
}

export function fmtTime(t) {
  const d = new Date(t);
  return `${d.toLocaleDateString()} ${d.toLocaleTimeString()}`;
}
